<template>
  <transition name="fade">
    <div class="layout">
      <Header />
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <Footer />
      <router-link
        class="pop"
        to="/abilityTest"
        v-show="this.$route.name != 'abilityTest'"
      ></router-link>
    </div>
  </transition>
</template>
<script>
import { Header, Footer } from "../index";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scope>
.pop {
  width: 375px;
  height: 98.5px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  // background-image: url("../../assets/images/footer.png");
  position: fixed;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue